export default __webpack_public_path__ + "static/portfolio_gallery_28-cea71768c757a1d478638f2294c3d45b.jpg";